const commission = {
  root: "commission",
  root_plural: "commissions",
};
export default commission;
